import { render } from "./OverlayInfoProvider.vue?vue&type=template&id=ca59344c"
import script from "./OverlayInfoProvider.vue?vue&type=script&lang=js"
export * from "./OverlayInfoProvider.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__